/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Not_Enough_PlayersInputs */



/**
* | output |
* | --- |
* | "Need at least 4 checked-in players" |
*
* @param {Err_Tournament_Not_Enough_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_not_enough_players = /** @type {((inputs?: Err_Tournament_Not_Enough_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Not_Enough_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au moins 4 joueurs pointés sont nécessaires")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se necesitan al menos 4 jugadores con check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("São necessários pelo menos 4 jogadores com check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sono necessari almeno 4 giocatori con check-in")
	return /** @type {LocalizedString} */ ("Need at least 4 checked-in players")
});